import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonGroup} from 'shells/button-group/button-group';
// @ts-expect-error - imported from .js/.jsx file
import {AlignCenterIcon} from 'shells/icon/svg/align-center-icon';
// @ts-expect-error - imported from .js/.jsx file
import {AlignLeftIcon} from 'shells/icon/svg/align-left-icon';
// @ts-expect-error - imported from .js/.jsx file
import {AlignRightIcon} from 'shells/icon/svg/align-right-icon';

type Position = 'left' | 'center' | 'right';
type FlexPosition = 'flex-start' | 'center' | 'flex-end';

export type Props = {
    currentPosition: string;
    onSetCurrentPosition: (value: Position | FlexPosition) => void;
    // Set to true to use flex-box values for position
    shouldUseFlexBoxValues?: boolean;
};

export function FormAlignmentSelector(props: Props) {
    const left = props.shouldUseFlexBoxValues ? 'flex-start' : 'left';
    const right = props.shouldUseFlexBoxValues ? 'flex-end' : 'right';

    return (
        <div className='flex'>
            <ButtonGroup>
                <Button
                    variant={props.currentPosition === left ? 'primary' : 'secondary'}
                    onClick={() => {
                        props.onSetCurrentPosition(left);
                    }}
                    icon={AlignLeftIcon}
                >
                    Left
                </Button>
                <Button
                    variant={props.currentPosition === 'center' ? 'primary' : 'secondary'}
                    onClick={() => {
                        props.onSetCurrentPosition('center');
                    }}
                    icon={AlignCenterIcon}
                >
                    Center
                </Button>
                <Button
                    variant={props.currentPosition === right ? 'primary' : 'secondary'}
                    onClick={() => {
                        props.onSetCurrentPosition(right);
                    }}
                    icon={AlignRightIcon}
                >
                    Right
                </Button>
            </ButtonGroup>
        </div>
    );
}
